import { type FC } from "react";
import { type ShopAccordionProps } from "../ShopAccordion";
import * as styles from "./styles.css";

export const Shop: FC<ShopAccordionProps> = ({
  totalNumber,
  shopInformations,
  gaAction,
  gaLabels,
  query,
}) => (
  <ul>
    {shopInformations.map(
      ({ detailUrlWithShopId, name, detailAddress, detailNearestStation }, index) => (
        <li key={detailUrlWithShopId} className={styles.mainTableList}>
          <span>
            <a
              href={detailUrlWithShopId}
              className="js-add-query-strings ga-click"
              data-ga-action={gaAction}
              data-ga-label={gaLabels[index]}
              data-query-str={query}
            >
              {name}
            </a>
          </span>
          {detailAddress && <p className="omit-text">{detailAddress}</p>}
          {detailNearestStation && <p className="omit-text">{detailNearestStation}</p>}
        </li>
      ),
    )}
    {totalNumber > 1 && (
      <p className="shop-num-outer">
        <span className="shop-num">{totalNumber}</span>
        店舗で募集中
      </p>
    )}
  </ul>
);
